/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_017: Question = {
  id: 'pres-017-superficie-ecosystemes-forestiers',
  oldId: '31',
  title: 'Superficie des écosystèmes forestiers',
  number: '3.1',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

const question_pres_017__v3: Question = {
  ...question_pres_017,
  frequency: 4,
};

export const question_pres_017_v2: Question = question_pres_017;
export const question_pres_017_v3: Question = question_pres_017__v3;
